import { useQuery } from "react-query";
import { getEmployeeStatus } from "../../../../../actions/Utilities/EmployeeStatus";

export default function useEmployeeStatus() {
  const {data, isFetching} = useQuery("GetEmployeeStatus", getEmployeeStatus, {
    refetchOnWindowFocus: false,
  });
  return {data, isFetching};
}
